<template>


	<div class="col-xs-12 col-sm-10 col-md-9 mobile-menu-container">

		<nav>
			<ul>
				<li v-if="!$root.checkingOut" v-for="link in $root.config.header_nav_links"><a :href="link.location">{{ link.title }}</a></li>
				<li class="buttons" v-if="$root.checkingOut"><a :class="{ 'no-background': $root.checkingOut }" :href="'tel:'+$root.locale.global.telephone" v-html="locale.text_call_us_on"></a></li>
				<li class="buttons" v-if="this.$root.authenticated"><router-link :class="{ 'no-background': $root.checkingOut }" :to="{ name: 'account.overview' }">My Account</router-link></li>
				<li class="buttons" v-if="this.$root.authenticated"><a :class="{ 'no-background': $root.checkingOut }" @click="logout">Logout</a></li>
				<li class="buttons" v-else><router-link :to="{ name: 'auth.login' }">Login or Sign up</router-link></li>
			</ul>

  			<router-link :to="{ name: 'cart.basket' }" id="cart">
				 <span class="fa fa-shopping-basket hidden-xs"><b>{{ $root.number_of_items_in_basket }}</b></span>
			 </router-link>
		</nav>

	</div>


</template>

<script>
    export default {
        data () {
            return {
                page: this.$route.name,
                full_name: 'My Account',
                builder: undefined,
                venue: "",
                image: "",
            }
        },
        computed: {
			locale: function () {
                return this.$root.locale.miscellaneous.header;
			}
		},
        methods: {
            /**
             * Handle logout
             */
            logout: function () {
                axios.post('/camp-booking/users/logout')
                    .then(response => {
                        this.$root.auth = response.data.data;
                        this.$root.setCookie('kingscamps_booking_id', null, -1, true);
                        this.$root.setCookie('kingscamps_booking_user_id', null, -1, true);
                        this.$root.setCookie('kingscamps_refresh_token', null, -1, true);
                        this.$root.setCookie('kingscamps_access_token', null, -1, true);
                        this.$router.push({ name: 'auth.login'})

                        /** Updating the basket count **/
                        this.$root.updateBasketCount();

                    })
            },
            update: function () {
                if (this.$root.authenticated) {
                    axios.get('/camp-booking/users/' + this.$root.auth.user_id)
                        .then(response => {
                            this.$root.auth = Object.assign(this.$root.auth, response.data.data);
                            this.full_name = response.data.data.first_name + ' ' + response.data.data.last_name;
                        })
                }
            }
        },
        watch: {
            "$root.authenticated": function () {
                this.update();
            },
            "$route": function () {
                this.update();
            }
        },
        created () {
            this.update();
        }
    }
</script>



// WEBPACK FOOTER //
// AuthHeader.vue?cd1e8388